// Utils
import FormatUtil from '@/utils/FormatUtil';

export default {
    /** @type { import('@/typedefs/inventory/partnerLocation').partnerLocation } */
    inboundPartneredLocations( location ) {
        return {
            ...location,
            friendly: FormatUtil.locationNameFriendly( location.name ),
            partnered: location.partnered || false,
        };
    },
};
